import InstitutionDetailsLayout from '@/features/institution/layouts/details';
import InstitutionTaxSelfCertificationForm from '@/features/institution/tax-self-certification/components/form';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';

const InstitutionOnboardingTaxSelfCertificationPage = () => {
  return (
    <InstitutionDetailsLayout detailsKey="taxSelfCertification" detailsType={INSTITUTION_DETAILS_TYPE.ONBOARDING}>
      <InstitutionTaxSelfCertificationForm />
    </InstitutionDetailsLayout>
  );
};
InstitutionOnboardingTaxSelfCertificationPage.displayName = 'InstitutionOnboardingTaxSelfCertificationPage';

export default InstitutionOnboardingTaxSelfCertificationPage;
